import React, { useState, useEffect, useRef } from "react";
import SelectAllButtonComponent from './selectAllButton.component';

function SelectAllButtonContainer({
  variant,
  actionItems,
  popperStyle,
  disablePortal,
  disabled
}) {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef(null)

  const handleToggleOpen = () => {
    setIsOpen((prev) => !prev)
  };

  const handleClose = (event) => {
    if(anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setIsOpen(false);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(isOpen);
  useEffect(() => {
    if (prevOpen.current === true && isOpen === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = isOpen;
  }, [isOpen]);

  if( !variant ){
    variant = "horizontal" 
  }

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setIsOpen(false);
    }
  }

  return (
    <SelectAllButtonComponent
      variant={variant}
      isOpen={isOpen}
      handleToggleOpen={handleToggleOpen}
      anchorRef={anchorRef}
      handleListKeyDown={handleListKeyDown}
      handleClose={handleClose}
      actionItems={actionItems}
      popperStyle={popperStyle}
      disablePortal={disablePortal}
      disabled={disabled}
    />
  );
}

export default SelectAllButtonContainer